<template>
  <div class="accords">
    <div class="heading1">
      Industrial Accords
      <hr class="gradientLine" />
    </div>
    <p class="">Coming soon...</p>
  </div>
</template>

<script>
import { useDocuments } from "@/composables/useDocuments";
import { LIST_ASSETS } from "@/store/operations";
import { useStore } from "vuex";
import { computed, ref } from "vue";
import principles from "@/components/accords/principles.js";
import { countries } from "@/components/Organisation/lib/countries";

export default {
  name: "Accords",
  components: {},
  setup() {
    const principleDropdown = ref(null);
    const countryDropDown = ref(null);
    const store = useStore();
    const dataType = "Accord";
    const { filter, filteredDocuments } = useDocuments(dataType, {
      refresh: true,
    });

    const filterCountry = (selectedItems) => {
      console.log(selectedItems);
      countryDropDown.value = selectedItems;
      // Reset the filter value
      delete filter.value.countries;

      for (const item of selectedItems) {
        if (item === "All") {
          delete filter.value.countries;
          break;
        }
        filter.value.countries = item;
      }
    };
    const filterPrinciple = (selectedItems) => {
      selectedItems = Object.values(selectedItems).map((item) =>
        Object.keys(principles).find((key) => principles[key].name === item)
      );
      filter.value.principles = selectedItems;

      console.log(selectedItems);
    };
    const filteredAccords_hack = computed(() => {
      // TODO: remove this hack, removes public kids of private parent
      const filtered = [];
      if (filteredDocuments.value?.length && store.state.assets?.Organisation) {
        for (const accord of filteredDocuments.value) {
          const parent = Object.values(store.state.assets.Organisation).find(
            (o) => o.repoId === accord.parentId
          );
          const parentIsPublic = parent && !parent.isPrivate;
          if (parentIsPublic) filtered.push(accord);
        }
      }
      return filtered.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    });

    const filterText = (text) => {
      if (text === null) {
        delete filter.value.name;
        return;
      }

      text = text.toLowerCase();

      filter.value = { name: text, description: text };
    };

    store.dispatch(LIST_ASSETS, { dataType });

    const onSearch = (value) => {
      const key = Object.keys(value)[0];
      principleDropdown.value = value;
      if (value[key] !== undefined) filter.value[key] = value[key];
      else delete filter.value[key];
    };

    return {
      countries,
      filteredAccords_hack,
      onSearch,
      principleDropdown,
      countryDropDown,
      filterCountry,
      filterText,
      principles,
      filterPrinciple,
    };
  },
};
</script>

<style scoped></style>
